module.exports = __webpack_public_path__ + "img/hr-level2addon_running_mask.16156b06.png";